<script setup lang="ts">
import { onMounted } from 'vue'

import { usePagination } from '../../composables/use-pagination'
import Icon from '../shared/Icon.vue'

import type { TeaserParagraph } from '../../utils/paragraph-schema/paragraphs.ts'
import type { ComposedPageMeta } from '@xcel-next/composer-schema'


const props = defineProps<{
  series: TeaserParagraph['teaser'][],
  pageMeta: ComposedPageMeta,
  isPreview?: boolean
}>()

const { paginationItems, addItemStyleClass, setBlockEntriesBasedOnViewport } = usePagination(
  props.series.length,
  (props.pageMeta.seriesIndex ?? 0) + 1
)

onMounted(() => {
  setBlockEntriesBasedOnViewport(props.series.length, (props.pageMeta.seriesIndex ?? 0) + 1)
})

function setFlickStyles (pageMeta: ComposedPageMeta, series: TeaserParagraph['teaser'][]): string {
  let styles = 'bx-series__flick-navi bx-form'
  if ((pageMeta.seriesIndex ?? 0) > 0 && (pageMeta.seriesIndex ?? 0) + 1 < series.length) {
    styles += ' bx-series__flick-navi--in-between'
  }
  return styles
}
</script>

<template>
  <div class="bx-content bx-series bx-series--navigation bx-typo--series">
    <div :class="setFlickStyles(pageMeta, series)">
      <a v-if="(pageMeta.seriesIndex ?? 0) > 0 && (pageMeta.seriesIndex ?? 0)+1 < series.length"
         class="bx-series__flick-left"
         :href="isPreview ? '#' : series[(pageMeta.seriesIndex ?? 0)-1].url">
        <div class="bx-form__button">
          <Icon name="arrow_series-left" />
          <span class="bx-series__button-text-left">Zurück</span>
        </div>
        <span class="bx-series__link-headline">{{ series[(pageMeta.seriesIndex ?? 0)-1].assetDisplayTitle || series[(pageMeta.seriesIndex ?? 0)-1].titleLong || series[(pageMeta.seriesIndex ?? 0)-1].titleShort }}</span>
      </a>
      <a v-if="(pageMeta.seriesIndex ?? 0)+1 < series.length"
         :class="{ 'bx-series__flick-left': (pageMeta.seriesIndex ?? 0) === 0, 'bx-series__flick-right': (pageMeta.seriesIndex ?? 0) > 0 }"
         :href="isPreview ? '#' : series[(pageMeta.seriesIndex ?? 0)+1].url">
        <div class="bx-form__button">
          <span class="bx-series__button-text-right">Weiter</span>
          <Icon name="arrow_series-right" />
        </div>
        <span class="bx-series__link-headline">{{ series[(pageMeta.seriesIndex ?? 0)+1].assetDisplayTitle || series[(pageMeta.seriesIndex ?? 0)+1].titleLong || series[(pageMeta.seriesIndex ?? 0)+1].titleShort }}</span>
      </a>
      <a v-if="(pageMeta.seriesIndex ?? 0)+1 === series.length"
         class="bx-series__flick-left"
         :href="isPreview ? '#' : series[0].url">
        <div class="bx-form__button">
          <span class="bx-series__button-text-right">Zur ersten Seite</span>
          <Icon name="arrow_series-right" />
        </div>
        <span class="bx-series__link-headline">{{ series[0].titleLong || series[0].titleShort }}</span>
      </a>
    </div>
    <div class="bx-series__pagination">
      <span>Seite</span>
      <ul class="bx-pager"
          :data-bx-pager-active="(pageMeta.seriesIndex ?? 0)+1"
          :data-bx-pager-num="series.length">
        <li v-for="pageNo in paginationItems"
            :key="pageNo"
            :class="addItemStyleClass(pageNo, (pageMeta.seriesIndex ?? 0)+1, series.length)">
          <a v-if="series[pageNo-1]?.assetId !== pageMeta.id"
             :href="isPreview ? '#' : series[pageNo-1].url">
            {{ pageNo }}
          </a>
          <span v-else>
            {{ pageNo }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
